<template>
  <button class="back-button" @click="$emit('click')">
    <i class="fas fa-arrow-left"></i>
  </button>
</template>

<script>
export default {
  name: "BackButton",
  emits: ["click"],
};
</script>

<style scoped>
.back-button {
  position: absolute;
  top: var(--spacing-lg);
  left: var(--spacing-lg);
  background: none;
  border: none;
  color: var(--text-color);
  font-size: var(--font-size-lg);
  cursor: pointer;
  z-index: 10;
  transition: transform var(--transition-fast);
}

.back-button:hover {
  transform: translateX(-3px);
}
</style>
